import { HilabsGrid, HilabsTypography } from '@hilabs-react-ui-components/core'
import { Suspense, lazy, useEffect } from 'react'
import { HILABS_HI } from '../constant/color'
import LoaderImg from '../assets/image/loader/loader.gif'
import { useNavigate, useLocation } from 'react-router-dom'
import { isTestPassed } from '../constant/auth'

const Loadable = Component =>
  function (props) {
    return (
      <Suspense fallback={<NPLoaderLazy />}>
        <Component {...props} />
      </Suspense>
    )
  }
export const NPLoaderLazy = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden' // Hide scroll
    return () => {
      document.body.style.overflow = '' // Show scroll
    }
  }, [])

  return (
    <HilabsGrid
      container
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        width: '100vw',
        zIndex: 9999,
      }}
      bgcolor={'#ffffff'}
    >
      <HilabsTypography className="blink" fontSize={100} fontWeight={700}>
        {HILABS_HI}Labs
      </HilabsTypography>
    </HilabsGrid>
  )
}
export const NPLoader = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden' // Hide scroll
    return () => {
      document.body.style.overflow = '' // Show scroll
    }
  }, [])
  return (
    <HilabsGrid
      container
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        width: '100vw',
        zIndex: 9999,
      }}
      bgcolor={'#ffffff'}
    >
      <img src={LoaderImg} alt="loader" height="auto" width={'400px'} />
    </HilabsGrid>
  )
}
export function NPLoaderWrapper({ isLoading, children }) {
  return (
    <>
      {isLoading && <NPLoader />}
      {children}
    </>
  )
}
export const LoginPage = Loadable(lazy(() => import('../pages/Login')))
export const RegisterPage = Loadable(lazy(() => import('../pages/Register')))
export const DashboardPage = Loadable(lazy(() => import('../pages/Dashboard')))
export const Timesheets = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Timesheets'))
)
export const HelpDeskLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Helpdesk'))
)
export const BrandingLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Branding'))
)
export const HolidayLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Holidays'))
)
export const NewToHiLabsLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/NewToHiLabs'))
)
export const TravelLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Travel'))
)
export const TalentAcquisitionLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/TalentAcquisition'))
)
export const PayrollLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Payroll'))
)
export const ExpenseLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Expenses'))
)
export const FacilitiesLazy = Loadable(
  lazy(() => import('../pages/DetailsPage/Page/Facilities'))
)
export const MemoryLaneLazy = Loadable(
  lazy(() => import('../pages/MemoryLane/MemoryLanePage'))
)
export const RecipesPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/RecipiesPage'))
)
export const BlogsPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/BlogsPage'))
)
export const EventPicturesLazy = Loadable(
  lazy(() => import('../pages/MemoryLane/MemoryLaneMockUp'))
)
export const NewsPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/NewsPage'))
)
export const SpotLigthPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/SpotLigth'))
)
export const RecipesDetailsPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/RecipesDetailsPage'))
)
export const NewsDetailsPage = Loadable(
  lazy(() => import('../pages/ExplorePage/NewsDetailPage'))
)
export const MASTERPAGE = Loadable(
  lazy(() => import('../pages/DetailsPage/MasterPage/MasterPage'))
)
export const LastMonthLazy = Loadable(
  lazy(() => import('../pages/LastMonth/LastMonth'))
)
export const LifeCanvasLazy = Loadable(
  lazy(() => import('../pages/LastMonth/LifeCanvas'))
)
export const LifeCanvasDetailsPageLazy = Loadable(
  lazy(() => import('../pages/LastMonth/LifeCanvasDetailsPage'))
)
export const ConversationsLazy = Loadable(
  lazy(() => import('../pages/Conversations'))
)
export const TravelDetailsPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/TravelDetailsPage'))
)
export const BisnessUpdateDetailsPageLazy = Loadable(
  lazy(() => import('../pages/ExplorePage/BusinessUpdateDetailsPage'))
)
export const HilabsTalksLazy = Loadable(
  lazy(() => import('../pages/HilabsTalks/HilabsTalks'))
)
export const LifeAtHiLabsLazy = Loadable(
  lazy(() => import('../pages/LifeAtHiLabs/LifeAtHiLabs'))
)
export const GivesBackDetailsPageLazy = Loadable(
  lazy(() => import('../pages/LifeAtHiLabs/page/GivesBackDetails'))
)
export const HilabsGotTalentLazy = Loadable(
  lazy(() => import('../pages/LifeAtHiLabs/page/HilabsgotTalentDetails'))
)
export const WomenInHiLabsPageLazy = Loadable(
  lazy(() => import('../pages/LifeAtHiLabs/page/WomenInHiLabsPage'))
)
export const MyPathToHiLabsLazy = Loadable(
  lazy(() => import('../pages/LifeAtHiLabs/page/MyPathDetails'))
)
export const DepartmentsLazy = Loadable(
  lazy(() => import('../pages/Departments/Departments'))
)

export const ProductsLazy = Loadable(
  lazy(() => import('../pages/Products/Products'))
)

export const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')))
export const HeaderWrapper = Loadable(
  lazy(() => import('../layouts/HeaderWrapper'))
)

// import AuthGuard from '../features/auth/guard/auth-guard'

export const AuthGuard = Loadable(
  lazy(() => import('../features/auth/guard/auth-guard'))
)

export const DashboardLayout = Loadable(
  lazy(() => import('../layouts/Dashboard'))
)
export const AuthLayout = Loadable(lazy(() => import('../layouts/Auth')))
export const HippaCompliance = Loadable(
  lazy(() => import('../pages/HippaCompliancePage'))
)
